import { REDUCER_NAME } from './const'
import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const CHANGE_LOGIN_DATA = NS + 'CHANGE_LOGIN_DATA'

export const LOGIN_REQUEST = NS + 'LOGIN_REQUEST'
export const LOGIN_ERROR = NS + 'LOGIN_ERROR'
export const LOGIN_SUCCESS = NS + 'LOGIN_SUCCESS'

export const LOGIN_PASSWORD_RESET_REQUIRED = 'LOGIN_PASSWORD_RESET_REQUIRED'

export const LOGOUT_SUCCESS = NS + 'LOGOUT_SUCCESS'


export const CHANGE_PASSWORD_REQUEST = NS + 'CHANGE_PASSWORD_REQUEST'
export const CHANGE_PASSWORD_SUCCESS = NS + 'CHANGE_PASSWORD_SUCCESS'
export const CHANGE_PASSWORD_ERROR = NS + 'CHANGE_PASSWORD_ERROR'



// WEBPACK FOOTER //
// ./src/modules/security/state/auth/type.js